import { Injectable } from '@angular/core';

import { BondedStockAdjustmentReason } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class BondedStockAdjustmentReasonService extends TmsWebBaseEditService<
  BondedStockAdjustmentReason,
  BondedStockAdjustmentReason
> {
  constructor() {
    super('BondedStockAdjustmentReason', $localize`Bonded Stock Adjustment Reason`);
  }
}
